<template>
  <div class="ad-overlay" @click="$emit('close')">
    <div class="ad-dialog" @click.stop>
      <div class="ad-icon" :style="{ background: color + '1a', color }">
        <PortalIcon :name="icon" :size="22" />
      </div>
      <h3 class="ad-title">{{ title }}</h3>
      <p class="ad-msg">{{ message }}</p>
      <div class="ad-actions">
        <button v-if="cancelText" class="ad-btn ad-cancel" @click="$emit('close')">
          {{ cancelText }}
        </button>
        <button
          class="ad-btn ad-confirm"
          :style="{ background: color }"
          @click="$emit(cancelText ? 'confirm' : 'close')"
        >
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PortalIcon from "./PortalIcon.vue";

const VARIANTS = {
  success: { icon: "CheckCircle2", color: "#16a34a" },
  error: { icon: "AlertTriangle", color: "#dc2626" },
  warn: { icon: "AlertTriangle", color: "#d97706" },
  info: { icon: "Info", color: "#003ca5" },
};

export default {
  name: "AlertDialog",
  components: { PortalIcon },
  props: {
    variant: { type: String, default: "info" },
    title: { type: String, default: "" },
    message: { type: String, default: "" },
    confirmText: { type: String, default: "Aceptar" },
    // Si se define, el diálogo entra en modo confirmación (dos botones).
    cancelText: { type: String, default: "" },
  },
  emits: ["confirm", "close"],
  computed: {
    icon() {
      return (VARIANTS[this.variant] || VARIANTS.info).icon;
    },
    color() {
      return (VARIANTS[this.variant] || VARIANTS.info).color;
    },
  },
};
</script>

<style scoped>
.ad-overlay {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.45);
}
.ad-dialog {
  width: 100%;
  max-width: 400px;
  background: var(--pt-card, #fff);
  color: var(--pt-text, #0f172a);
  border-radius: 16px;
  padding: 24px;
  text-align: center;
}
.ad-icon {
  width: 48px;
  height: 48px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
}
.ad-title {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 6px;
}
.ad-msg {
  font-size: 14px;
  color: var(--pt-dim, #64748b);
  margin: 0 0 20px;
}
.ad-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.ad-btn {
  padding: 9px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: 0;
  cursor: pointer;
  font-family: inherit;
}
.ad-cancel {
  background: var(--pt-track, #f0f4fa);
  color: var(--pt-dim, #475569);
}
.ad-confirm {
  color: #fff;
}
</style>
